import { render, staticRenderFns } from "./OnBoardingCarousel.vue?vue&type=template&id=0c823424&scoped=true"
import script from "./OnBoardingCarousel.vue?vue&type=script&lang=js"
export * from "./OnBoardingCarousel.vue?vue&type=script&lang=js"
import style0 from "./OnBoardingCarousel.vue?vue&type=style&index=0&id=0c823424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c823424",
  null
  
)

export default component.exports